module.exports = __webpack_public_path__ + "static/media/floral-leaves-and-vines-with-bud-design-svgrepo-com.079ded11.svg";